import { ETH_PRICE, GET_BLOCK, TOKEN_DATA } from 'apollo/queries';
import React from 'react'
import { request } from "graphql-request"
import dayjs from 'dayjs';


const MJT_GRAPH = "https://thegraph.kcc.network/subgraphs/name/mojito/swap";
const KCC_BLOCK_GRAPH =
  "https://thegraph.kcc.network/subgraphs/name/kcc-blocks";


export const getETHPrice = async (block?:number) => {
  const result = await request(MJT_GRAPH, ETH_PRICE(block))
  return result?.bundles[0]?.ethPrice ? Number(result.bundles[0].ethPrice) : 0
}

export async function getLatestBlock(timestamp?: number) {
  //  a few blocks behind the blockchain,so we write a hack here
  const utcCurrentTime = timestamp ?? dayjs().unix();
  const res = await request(KCC_BLOCK_GRAPH, GET_BLOCK, {
    timestampFrom: utcCurrentTime,
    timestampTo: utcCurrentTime + 600,
  });

  const block =
    res?.blocks[0]?.number ?? (await getLatestBlock(dayjs().unix() - 600));
  return Number(block);
}



export const getTokenPrice = async (token, ePrice?: number) => {
  const ethPrice = ePrice ?? (await getETHPrice())
  const tokens = await request(MJT_GRAPH, TOKEN_DATA(token.toLowerCase()), {
    id: token,
  })
  const tokenPrice = tokens?.tokens[0]?.derivedETH ? tokens.tokens[0].derivedETH : 0
  return ethPrice * tokenPrice
}


export function useTokenPrice(tokenAddress: string) {
  const [price, setPrice] = React.useState<number>(0)
  React.useEffect(() => {
    async function getPrice() {
      const p = await getTokenPrice(tokenAddress.toLowerCase())
      setPrice(() => p)
    }
    getPrice()
  }, [tokenAddress])
  return price
}